import {emotionStyled} from '@packages/utilities/styled';
import {hideOutlineAtom} from '../../themes';

export const CardView = emotionStyled('div')(
  {
    backgroundColor: '$background1',
    color: '$textPrimary',
    display: 'block',
    height: 'auto',
    padding: '$2',
    borderRadius: '$2',
    position: 'relative',
    width: '100%',
  },
  {
    componentName: 'Card',
    variants: {
      elevation: {
        0: {
          boxShadow: '$0',
        },
        1: {
          boxShadow: '$menu',
        },
        2: {
          boxShadow: '$menu',
        },
        3: {
          boxShadow: '$menu',
        },
        4: {
          boxShadow: '$menu',
        },
        5: {
          boxShadow: '$menu',
        },
      },
      size: {
        medium: {},
        'x-large': {
          padding: '$3',
        },
      },
      hasSoftCorners: {
        true: {
          borderRadius: '$6',
        },
      },
      isScrollable: {
        true: {
          '&&': {
            overflowY: 'auto',
          },
        },
      },
      isSeamless: {
        true: {
          '&&': {
            padding: 0,
          },
        },
      },
    },
    composes: [hideOutlineAtom],
  }
);

export const CardBodyView = emotionStyled('div')(
  {
    height: 'auto',
    width: '100%',
    display: 'block',
    position: 'relative',
    padding: '$2',
    outline: '2px solid transparent',
  },
  {
    variants: {
      size: {
        medium: {},
        'x-large': {
          padding: '$3',
        },
      },
      isScrollable: {
        true: {
          '&&': {
            overflowY: 'auto',
          },
        },
      },
      isSeamless: {
        true: {
          '&&': {
            padding: 0,
          },
        },
      },
    },
  }
);
